import { Column, Data, FieldType, Section, Table } from "../../../../ui"
import { Data2 } from "../../../types"

type Props = {
    rows: Data2[]
    readOnly?: boolean
    onCreate?: () => void
    onEditRow?: (email: string) => void
    onRemoveRow?: (email: string) => void
}

export const EmailsTable = (props: Props) => {
    const { rows, readOnly, onCreate, onEditRow, onRemoveRow } = props

    const columns: Column[] = [
        {
            name: 'email',
            type: FieldType.TEXT,
            label: ''
        }
    ]

    return (
        <Section
            id="emails"
            collapsable
            defaultExpanded
        >
            <Table
                columns={columns}
                rows={rows as Data[]}
                rowId='email'
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onCreate}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
